import { Attribution } from "../types/common";

// Module-scoped cache shared by the chat 4-destinations grid fetch (writes
// into it when a DESTINATION intent resolves) and the itinerary-details
// slideshow (reads from it on mount). Persists for the lifetime of the page
// load — a refresh clears it, nav between routes does not. Keyed by the same
// `${city}|${country}` tuple both callers already use, so the slideshow
// transparently reuses whatever the chat pre-fetched, avoiding a second
// Unsplash call for the same city.

export type CityImageCacheEntry = {
  urls: string[];
  attributions: (Attribution | null)[];
};

const cache = new Map<string, CityImageCacheEntry>();

export function cityImageCacheKey(city: string, country?: string): string {
  return `${(city || "").toLowerCase()}|${(country || "").toLowerCase()}`;
}

export function getCityImageCache(key: string): CityImageCacheEntry | undefined {
  return cache.get(key);
}

export function setCityImageCache(key: string, entry: CityImageCacheEntry): void {
  cache.set(key, entry);
}

export function hasCityImageCache(key: string): boolean {
  return cache.has(key);
}
